import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { PricingCard } from "@/components/PricingCard";
import type { SubscriptionInterval, PlanId } from "@/types/payment";

interface PlanSelectorProps {
  interval: SubscriptionInterval;
  onIntervalChange: (checked: boolean) => void;
  onSelectPlan: (planId: PlanId) => void;
  plans: {
    [key in PlanId]: {
      id: PlanId;
      name: string;
      prices: {
        month: string;
        year: string;
      };
      features: string[];
    };
  };
}

export const PlanSelector = ({
  interval,
  onIntervalChange,
  onSelectPlan,
  plans,
}: PlanSelectorProps) => {
  return (
    <>
      <div className="flex items-center justify-center gap-4 mb-8">
        <Label htmlFor="billing-interval">Monthly</Label>
        <Switch
          id="billing-interval"
          checked={interval === 'year'}
          onCheckedChange={onIntervalChange}
        />
        <div className="flex items-center gap-2">
          <Label htmlFor="billing-interval">Annual</Label>
          <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">
            Save 20%
          </span>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {(Object.entries(plans) as [PlanId, typeof plans[PlanId]][]).map(([planId, plan]) => (
          <PricingCard
            key={planId}
            tier={planId}
            price={plan.prices[interval]}
            features={plan.features}
            onSelect={() => onSelectPlan(planId)}
          />
        ))}
      </div>
    </>
  );
};